import { AssetCollection, AssetFile } from "../manifest/models/asset.models";
import { ExperimentCondition } from "../manifest/models/condition.models";
import { combineUrl } from "../utils/url_utils";

function assetPath(
  collection: AssetCollection,
  filename: string,
  options?: {
    conditionSpecific?: boolean;
    condition?: ExperimentCondition;
  }
): string {
  options ??= { conditionSpecific: false, condition: undefined };
  return combineUrl(
    options.conditionSpecific == true
      ? options.condition?.asset_root
      : undefined,
    collection.asset_root,
    filename
  );
}

export function collectAssetFiles(
  collection: AssetCollection,
  condition?: ExperimentCondition
): AssetFile[] {
  if (collection.files != null) {
    return collection.files.map((file) => {
      const conditionSpecific: boolean =
        file.condition_specific ?? collection.condition_specific ?? false;

      return {
        ...file,
        filename: assetPath(collection, file.filename, {
          conditionSpecific: conditionSpecific,
          condition: condition,
        }),
        tags: [...(file.tags ?? []), ...(collection.tags ?? [])],
      };
    });
  } else if (collection.file_index != null) {
    return collectAssetIndex(collection, condition);
  } else {
    throw new Error(
      `FATAL: No file list or file index specified for asset collection ${collection.id}`
    );
  }
}

function collectAssetIndex(
  collection: AssetCollection,
  condition?: ExperimentCondition
): AssetFile[] {
  const files: AssetFile[] = [];
  const index = collection.file_index!;
  const tagIndex = index.file_tags;
  const tagPattern = index.file_tag_pattern;

  for (let i = index.start_index; i <= index.total_files; i++) {
    const id = index.id_pattern.replace("{index}", i.toString());
    const filename = assetPath(collection, `${i}.${index.file_extension}`, {
      conditionSpecific: collection.condition_specific,
      condition: condition,
    });

    /// Combine the collection tags with any file specific tags found by referencing the current index id
    /// with the file_tags TagIndex.
    let tags: string[] = [
      ...(collection.tags ?? []),
      ...(tagIndex != null ? (tagIndex[id] ?? tagIndex[i] ?? []) : []),
      ...(tagPattern != null
        ? [tagPattern.replace("{index}", i.toString())]
        : []),
    ];

    files.push({
      id: id,
      filename: filename,
      tags: tags,
    });
  }

  return files;
}
